import React, { useEffect, useState } from 'react'
import { OverlayTrigger, Button, Modal, Row, Col, Form, Table } from 'react-bootstrap'
import { MdFilterList, MdAddCircle, MdEdit, MdDelete, MdVisibility } from 'react-icons/md';
import { Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import loading from '../../assets/images/common/loading.gif';
import axios from 'axios';
import AppDataGrid from '../../components/common/AppDataGrid';

const BusRoutes = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [showStopsModal, setShowStopsModal] = useState(false);
  const [selectedRouteStops, setSelectedRouteStops] = useState([]);
  const [selectedRouteName, setSelectedRouteName] = useState("");
  const handleShowFilterModal = () => setShowFilterModal(true);
  const [isLoading, setIsLoading] = useState(true);
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const userData = sessionStorage.getItem('user');
  const handleCloseFilterModal = () => setShowFilterModal(false);
  const handleCloseStopsModal = () => setShowStopsModal(false);
  const userObj = JSON.parse(userData);
  const [Routes, setRoutes] = useState([]);
  const [startlocations, setStartlocations] = useState([]);
  const [form, setForm] = useState({
    route_name: "",
    action: "FILTER"
  });

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setForm((prevForm) => ({ ...prevForm, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.post(`${baseUrl}/routes/${userObj.school_id}`, {
        params: {
          action: "FILTER",
          include_inactive: true,
          route_name: form.route_name || null,
          start_location: form.start_location || null,
          end_location: form.end_location || null,
        },
      });
      setRoutes(Array.isArray(data) ? data : []);
      setShowFilterModal(false);
    } catch (error) {
      console.error("Error fetching filtered data:", error);
      setRoutes([]);
      setShowFilterModal(false);
    }
  };

  useEffect(() => { startlocationData(); }, []);

  const startlocationData = async () => {
    try {
      const response = await axios.post(baseUrl + "/routelocation/", {
        action: "READ",
        school_id: userObj.school_id
      });
      setStartlocations(response.data);
    } catch (error) {
      console.log("Error fetching data:", error);
    }
  };

  const handleSearchChange = (event) => setSearchQuery(event.target.value);

  // Function to handle view stops click
  const handleViewStopsClick = (route) => {
    setSelectedRouteStops(route.stops || []);
    setSelectedRouteName(route.route_name || "Route Stops");
    setShowStopsModal(true);
  };

  const columns = [
    {
      field: 'route_name',
      headerName: 'Route Name',
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value || ''}><span>{params.value}</span></Tooltip>
      ),
    },
    {
      field: 'start_location_name',
      headerName: 'Start Location',
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value || ''}><span>{params.value}</span></Tooltip>
      ),
    },
    {
      field: 'end_location_name',
      headerName: 'End Location',
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value || ''}><span>{params.value}</span></Tooltip>
      ),
    },
    {
      field: 'estimated_time',
      headerName: 'Estimated Time',
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value || ''}><span>{params.value}</span></Tooltip>
      ),
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      renderCell: (params) => {
        const val = params.value || 'InActive';
        return <span>{val}</span>;
      },
    },
    {
      field: 'stops',
      headerName: 'Stops',
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <Tooltip title="View Stops">
          <span 
            className="commonActionIcons" 
            onClick={() => handleViewStopsClick(params.row)}
            style={{ 
              color: '#1976d2', 
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              // width: '100%',
              // height: '100%'
            }}
          >
            <MdVisibility size={20} />
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <div className="tableActions">
          <Tooltip title="Edit">
            <span className="commonActionIcons" onClick={() => handleEditClick(params.row.route_id)}>
              <MdEdit />
            </span>
          </Tooltip>
          <Tooltip title="Delete">
            <span className="commonActionIcons" onClick={() => handleDeleteClick(params.row.route_id, params.row.status)}>
              <MdDelete />
            </span>
          </Tooltip>
        </div>
      ),
    },
  ];

  // Search (client-side)
  const normalized = (v) => (v ?? '').toString().toLowerCase().replace(/[-\s]+/g, '');
  const searchableColumns = [
    (row) => (row.route_name),
    (row) => (row.start_location),
    (row) => (row.end_location),
    (row) => (row.estimated_time),
    (row) => (row.status),
  ];
  const normalizedQuery = normalized(searchQuery);
  const filteredRecords = (Routes || []).filter((item) =>
    searchableColumns.some((selector) => {
      const value = selector(item) || '';
      return normalized(value).includes(normalizedQuery);
    })
  );

  const handleReset = async (e) => {
    e.preventDefault();
    setForm({ route_name: "", start_location: "", end_location: "" });
    setShowFilterModal(true);
    fetchData();
  };

  useEffect(() => {
    setIsLoading(true);
    fetchData().finally(() => setIsLoading(false));
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(`${baseUrl}/routes/${userObj.school_id}`, {
        params: { action: "READ", include_inactive: true },
      });
      setRoutes(response.data);
    } catch (error) {
      console.log("Error fetching data:", error);
    }
  };

  const handleEditClick = (route_id) => {
    const routesmasterToEdit = Routes.find(route => route.route_id === route_id);
    if (routesmasterToEdit) {
      navigate("/addbusroutes", { state: { routesData: routesmasterToEdit } });
    } else {
      console.error(`Routes with ID ${route_id} not found.`);
    }
  };

  const handleDeleteClick = async (route_id, currentStatus) => {
    const isActive = (currentStatus || '').toLowerCase() === 'active';
    if (!isActive) {
      return;
    }

    const ok = window.confirm('Are you sure you want to mark this route as InActive?');
    if (!ok) return;

    try {
      await axios.patch(`${baseUrl}/routes/${route_id}/status`, null, {
        params: {
          school_id: userObj.school_id,
          status: 'InActive',
        }
      });

      setRoutes(prev =>
        prev.map(r => r.route_id === route_id ? { ...r, status: 'InActive' } : r)
      );
    } catch (error) {
      console.error("Failed to update status", error);
    }
  };

  return (
    <div className='pageBody'>
      <div className='commonDataTableHead'>
        <div className='d-flex justify-content-between align-items-center w-100'>
          <div className='d-flex align-items-center' style={{ gap: "10px" }}>
            <h6 className='commonTableTitle'>Routes</h6>
          </div>
          <div className="">
            <input
              type="text"
              placeholder="Search..."
              value={searchQuery}
              className="searchInput"
              onChange={handleSearchChange}
            />
          </div>
          <div className="d-flex align-items-center" style={{ gap: 6 }}>
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Filter</Tooltip>}>
              <Button className="secondaryBtn" variant="secondary" onClick={handleShowFilterModal}>
                <MdFilterList />
              </Button>
            </OverlayTrigger>
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Add</Tooltip>}>
              <Button className="primaryBtn" variant="primary" onClick={() => navigate("/addbusroutes")}>
                <MdAddCircle />
              </Button>
            </OverlayTrigger>
          </div>
        </div>
      </div>

      <div className='commonTable'>
        <div className="tableBody">
          {isLoading ? (
            <div className="loadingContainer">
              <img src={loading} alt="Loading..." className="loadingGif" />
            </div>
          ) : (
            <AppDataGrid
              rows={filteredRecords.length ? filteredRecords : []}
              columns={columns}
              getRowId={(row) => row.route_id}
              pageSizeOptions={[10, 20, 50]}
              showToolbar={false}
              pagination
              density="compact"
              maxHeight={550}
            />
          )}
        </div>
      </div>

      {/* Filter Modal - Keep as is */}
      <Modal show={showFilterModal} onHide={handleCloseFilterModal} className="commonFilterModal">
        <Modal.Header closeButton className="modalHeaderFixed">
          <Modal.Title>Filter</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col xs={12}>
              <div className="commonInput">
                <Form.Group controlId="levelName">
                  <Form.Label>Route Name</Form.Label>
                  <Form.Control
                    type="text"
                    id="route_name"
                    value={form.route_name}
                    placeholder="Enter route name"
                    onChange={handleInputChange}
                    onKeyDown={(e) => {
                      if (e.key === ' ' && e.target.selectionStart === 0) e.preventDefault();
                    }}
                    maxLength={30}
                  />
                </Form.Group>
              </div>
            </Col>
            <Col xs={12}>
              <div className='commonInput'>
                <Form.Group controlId="month_name">
                  <Form.Label>Start Location</Form.Label>
                  <Form.Select
                    name="start_location"
                    id="start_location"
                    value={form.start_location}
                    onChange={(e) => setForm({ ...form, start_location: e.target.value })}>
                    <option value="" disabled hidden>Select Start Location</option>
                    {(startlocations || [])
                      .filter((startlocation) => startlocation.status === "Active")
                      .map((startlocation) => (
                        <option key={startlocation.route_location_id} value={startlocation.route_location_id}>
                          {startlocation.location_name}
                        </option>
                      ))}
                  </Form.Select>
                </Form.Group>
              </div>
            </Col>
            <Col xs={12}>
              <div className='commonInput'>
                <Form.Group controlId="month_name">
                  <Form.Label>End Location</Form.Label>
                  <Form.Select
                    name="end_location"
                    id="end_location"
                    value={form.end_location}
                    onChange={(e) => setForm({ ...form, end_location: e.target.value })}>
                    <option value="" disabled hidden>Select End Location</option>
                    {(startlocations || [])
                      .filter((startlocation) => startlocation.status === "Active")
                      .map((startlocation) => (
                        <option key={startlocation.route_location_id} value={startlocation.route_location_id}>
                          {startlocation.location_name}
                        </option>
                      ))}
                  </Form.Select>
                </Form.Group>
              </div>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="modalFooterFixed">
          <Button variant="secondary" className="btn-info clearBtn me-2" onClick={handleReset}>
            Reset
          </Button>
          <div>
            <Button variant="secondary" className="btn-danger secondaryBtn me-2" onClick={handleCloseFilterModal}>
              Cancel
            </Button>
            <Button variant="primary" className="btn-success primaryBtn" onClick={handleSubmit}>
              Search
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* Stops Details Modal - Centered */}
      <Modal 
        show={showStopsModal} 
        onHide={handleCloseStopsModal} 
        size="lg" 
        centered
        style={{ height: '80vh' }} 
        dialogClassName="custom-modal" 
      >
        <Modal.Header closeButton>
          <Modal.Title className="w-100 text-center">
            Stops for {selectedRouteName}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>
          {selectedRouteStops.length > 0 ? (
            <div className="table-responsive">
              <Table striped bordered hover>
                <thead>
                  <tr>
                    {/* <th>#</th> */}
                    <th>Stop Name</th>
                    <th>Sequence</th>
                    <th>Pickup Time</th>
                    <th>Drop Time</th>
                    <th>Latitude</th>
                    <th>Longitude</th>
                    {/* <th>Status</th> */}
                  </tr>
                </thead>
                <tbody>
                  {selectedRouteStops.map((stop, index) => (
                    <tr key={index}>
                      {/* <td>{index + 1}</td> */}
                      <td>{stop.stop_name }</td>
                      <td>{stop.stop_sequence }</td>
                      <td>{stop.pickup_time }</td>
                      <td>{stop.drop_time }</td>
                      <td>{stop.latitude }</td>
                      <td>{stop.longitude }</td>
                      {/* <td>
                        <span 
                          className={`badge ${(stop.status || '').toLowerCase() === 'active' ? 'bg-success' : 'bg-secondary'}`}
                        >
                          {stop.status}
                        </span>
                      </td> */}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ) : (
            <div className="text-center py-4">
              <p>No stops available for this route.</p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button variant="secondary" className="btn-danger secondaryBtn" onClick={handleCloseStopsModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default BusRoutes;